import React from "react";
import {Col, Row} from '@themesberg/react-bootstrap';
import BasePage from "./../base/BasePage";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {
  estimateKeyboardHeightPx,
  isEmpty,
  isResponseOk,
  isValidEmail, navigate,
  navigateBack,
  queryParams,
  setReactInputValue
} from "enqc-utilities/src/utils/Utilities";
import label from "enqc-utilities/src/label/Label";
import {toasting} from "../base/BaseComponent";
import {isValidNumber} from "libphonenumber-js";
import {AuthConsumer} from "../../context/AuthContext";
import AssemblyFormBasicInformationCard from "../../components/assembler/AssemblyFormBasicInformationCard";
import AssemblyControllerFWVersionFormCard from "../../components/assembler/AssemblyControllerFWVersionFormCard";
import AssemblyComponentFormCard from "../../components/assembler/AssemblyComponentFormCard";
import AssemblyRectifierControllerFormCard from "../../components/assembler/AssemblyRectifierControllerFormCard";
import {DONE, POSTPONED, QC_RETURNED, SUSPENDED} from "enqc-utilities/src/utils/Global";
import AssemblyPage from "./AssemblyPage";


const MAX_FORM = 3;

class AssemblyFormControlPage extends BasePage{

  constructor(props) {
    super(props);

    let reference = queryParams(this.props, 'reference')
    let validation = this.defaultValidation()
    let validationMessage = this.defaultValidationMessage()
    let formStep = 1
    this.state = {
      reference:reference,
      assembly : {},
      formStep : formStep,
      validation : validation,
      validationMessage : validationMessage,
      // scannerValue : '',
      scannerFocused:false,
    }
    this.pageRef = React.createRef();
    this.assemblyFormBasicInformationRef = React.createRef()
    this.assemblyControllerFWVersionFormRef = React.createRef();
    this.assemblyComponentRef = React.createRef();
    this.assemblyRectifierControllerRef = React.createRef();
    this.scannerInputRef = React.createRef()
  }

  defaultValidation = () =>{
    let validation = {};
    validation.firstname = true ;
    validation.lastname = true ;
    validation.birthdate = true
    validation.mobilePhone = true
    validation.gender = true ;
    validation.email = true
    validation.address = true ;
    validation.province = true ;
    validation.city = true
    validation.district = true ;
    validation.village = true
    return validation ;
  }
  defaultValidationMessage = () =>{
    let validationMessage = {};
    validationMessage.firstname = "" ;
    validationMessage.lastname = "" ;
    validationMessage.birthdate = ""
    validationMessage.mobilePhone = ""
    validationMessage.gender = "" ;
    validationMessage.email = ""
    validationMessage.address = "" ;
    validationMessage.province = "" ;
    validationMessage.city = ""
    validationMessage.district = "" ;
    validationMessage.village = ""
    return validationMessage ;
  }
  componentDidMount() {
    super.componentDidMount();
    if(this.props?.navBar?.current){
      this.props.navBar.current.updateNavBarItems([AssemblyFormControlPage.PAGE_CONF])
    }
    this.closePreLoader()
    this.assemblyControllerFWVersionFormRef.current.start()
    this.fetchAssemblyDetail()
    // const scannerInput = document.getElementById("scanner-input");
    // if (scannerInput) {
    //   scannerInput.focus()
    // }

    setTimeout(() => {
      const scannerInput = document.getElementById("scanner-input");
      if (scannerInput) {
        scannerInput.focus();
      }
    }, 300); // delay ensures element is mounted

    document.addEventListener("focusin", this.enforceInputFocus);
  }


  componentWillUnmount() {
    document.removeEventListener("focusin", this.enforceInputFocus);
  }


  enforceInputFocus = (e) => {
    const isInsidePage = this.pageRef.current?.contains(e.target);
    if (!isInsidePage) return;

    const allowedTags = ['input', 'textarea'];
    const allowedIds = ['scanner-input'];

    const tag = e.target.tagName?.toLowerCase();
    const id = e.target.id;

    const isAllowed = allowedTags.includes(tag) || allowedIds.includes(id);

    if (!isAllowed) {
      e.preventDefault();
      e.stopPropagation();

      const scannerDiv = document.getElementById("scanner-input");
      if (scannerDiv && scannerDiv !== document.activeElement) {
        scannerDiv.focus();
      }
    }
  };

  onChangeGeneralForm(field, value){
    let {assembly, validation, validationMessage} = this.state
    if(field==='firstname'){
      validation.firstname = true
      validationMessage.firstname = ""
    }
    if(field==='email'){
      validation.email = true
      validationMessage.email = ""
    }
    if(field==='mobilePhone'){
      validation.mobilePhone = true
      validationMessage.mobilePhone = ""
    }
    if(field==='province'){
      validation.province = true
      validationMessage.province = ""
    }
    if(field==='city'){
      validation.city = true
      validationMessage.city = ""
    }
    if(field==='district'){
      validation.district = true
      validationMessage.district = ""
    }
    if(field==='village'){
      validation.village = true
      validationMessage.village = ""
    }
    assembly[field] = value
    this.setState({assembly, validation, validationMessage})
  }

  async validateFormSubmit() {
    // await super.validateFormSubmit();
    let {assembly, validation, validationMessage} = this.state
    let valid = true ;
    validation = this.defaultValidation()
    validationMessage = this.defaultValidationMessage()
    if(isEmpty(assembly.mobilePhone) || assembly.mobilePhone.length <=2){
      validation.mobilePhone = false
      validationMessage.mobilePhone = label.PleaseEnterCorrectPhoneNumber
      valid = false ;
    }
    if(!isValidNumber(assembly.mobilePhone, 'ID')){
      validation.mobilePhone = false
      validationMessage.mobilePhone = label.PleaseEnterCorrectPhoneNumber
      valid = false ;
    }
    if(isEmpty(assembly.firstname) || assembly.firstname.length <=2){
      validation.firstname = false
      validationMessage.firstname = label.PleaseEnterFirstName
      valid = false ;
    }
    if(isEmpty(assembly.email) || assembly.email.length <=2){
      validation.email = false
      validationMessage.email = label.PleaseEnterEmail
      valid = false ;
    }
    if(!isValidEmail(assembly.email)){
      validation.email = false
      validationMessage.email = label.PleaseEnterCorrectEmail
      valid = false ;
    }

    if(!isEmpty(assembly.address) || !isEmpty(assembly.province) || !isEmpty(assembly.city) || !isEmpty(assembly.district) || !isEmpty(assembly.village)){
      if(isEmpty(assembly.address) || assembly.address.length <=2){
        validation.address = false
        validationMessage.address = label.PleaseEnterAddress
        valid = false ;
      }
      if(isEmpty(assembly.province)){
        validation.province = false
        validationMessage.province = label.PleaseSelectProvince
        valid = false ;
      }
      if(isEmpty(assembly.city)){
        validation.city = false
        validationMessage.city = label.PleaseSelectCity
        valid = false ;
      }
      if(isEmpty(assembly.district)){
        validation.district = false
        validationMessage.district = label.PleaseSelectDistrict
        valid = false ;
      }
      if(isEmpty(assembly.village)){
        validation.village = false
        validationMessage.village = label.PleaseSelectVillage
        valid = false ;
      }
    }
    this.setState({assembly, validation, validationMessage})
  }

  fetchAssemblyDetail(){
    let {reference} = this.state
    this.showPostProgress()
    this.get(Endpoint.API.ASSEMBLY, {
      params :{
        reference : reference
      }
    }, null, response=>{
      this.closePostProgress()
      if(response.code===200){
        let assembly = response.data
        let {assemblyStatus} = assembly
        let valid = true ;
        if(assemblyStatus.id===DONE){
          toasting.error(label.TheAssemblyHasBeenDone)
          valid = false
        }else if(assemblyStatus.id===POSTPONED){
          toasting.error(label.TheAssemblyHasBeenPostponed)
          valid = false
        }else if(assemblyStatus.id===SUSPENDED){
          toasting.error(label.TheAssemblyHasBeenSuspended)
          valid = false
        }else if(assemblyStatus.id===QC_RETURNED){
          toasting.error(label.TheAssemblyHasBeenReturnedByQC)
          valid = false
        }
        this.setState({
          assembly:assembly,
        }, () => {
          if(!valid){
            setTimeout(()=>{
              navigateBack(this.props)
            }, 3000)
          }
        })
      }else{
        this.props.history.goBack();
      }
    }, true, true)
  }

  validate(){

  }

  nextPage(){
    let {assembly} = this.state
    if(!assembly.id){
      return
    }
    let {formStep} = this.state
    if(formStep<MAX_FORM){
      formStep = formStep+1;
      this.placeDefaultScannerInput()
      this.setState({formStep}, () => {
        this.forceUpdate()
        if(formStep==1 && this.assemblyControllerFWVersionFormRef){
          this.assemblyControllerFWVersionFormRef.current.start()
        }
        if(formStep==2 && this.assemblyComponentRef){
          this.assemblyComponentRef.current.start()
        }
        if(formStep==3 && this.assemblyRectifierControllerRef){
          this.assemblyRectifierControllerRef.current.start()
        }
      })
    }
  }

  previousPage(){
    let {assembly} = this.state
    if(!assembly.id){
      return
    }
    let {formStep} = this.state
    if(formStep>1){
      formStep = formStep-1;
      this.placeDefaultScannerInput()
      this.setState({formStep}, () => {
        this.forceUpdate()
        if(formStep==1 && this.assemblyControllerFWVersionFormRef){
          this.assemblyControllerFWVersionFormRef.current.start()
        }
        if(formStep==2 && this.assemblyComponentRef){
          this.assemblyComponentRef.current.start()
        }
        if(formStep==3 && this.assemblyRectifierControllerRef){
          this.assemblyRectifierControllerRef.current.start()
        }
      })
    }
  }
  placeDefaultScannerInput(){
    const defaultScannerWrapper = document.getElementById("default-scanner-wrapper")
    const isEmpty = defaultScannerWrapper.innerText.trim() === "";
    if(isEmpty) {
      const scannerInput = document.getElementById("scanner-input")
      scannerInput.innerHTML = ''
      defaultScannerWrapper.appendChild(scannerInput)
    }
  }


  updateProperties(key, value){
    let {assembly} = this.state
    assembly[key] = value
    this.setState({assembly})
  }

  submitUpdate(assemblyStatus){
    let {assembly} = this.state
    assembly.serialComponent.inspection = {}
    this.post(Endpoint.API.UPDATE_ASSEMBLY+"?assemblyStatusId="+assemblyStatus.id, assembly,
        null, (res)=>{
            if(isResponseOk(res)){
                let assembly = res.data
                toasting.success(label.TheAssemblyHasBeenSubmitted)
                // navigate(this.props, AssemblyPage.ENDPOINT)
                // alert("sould be back")
                navigateBack(this.props)
            }
        }, true, true)
  }

  render(){
    let {assembly, formStep, validation, validationMessage, scannerValue, scannerFocused} = this.state
    if(isEmpty(assembly)){
        assembly = {}
    }
    let user = assembly.user?assembly.user:{}
    return (
        <AuthConsumer>
          {({ isAuth, refresh }) => {
            return (
                <div style={{paddingBottom:estimateKeyboardHeightPx()+"px"}} ref={this.pageRef}>
                  <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2">
                    <h4>{label.AssemblyFormSubmission}</h4>
                    <div>
                      {/*<input*/}
                      {/*    id="scanner-input"*/}
                      {/*    type="text"*/}
                      {/*    // readOnly={true}*/}
                      {/*    // inputMode="none"*/}
                      {/*    autoFocus="true"*/}
                      {/*    style={{ position: "relative" }}*/}
                      {/*    value={scannerValue}*/}
                      {/*    onChange={event => {*/}
                      {/*      let value = event.target.value*/}
                      {/*      let enter = false ;*/}
                      {/*      if(/[\r\n\t]/.test(value)){*/}
                      {/*        enter = true*/}
                      {/*        value = value.replace(/[\r\n\t]+/g, '');*/}
                      {/*      }*/}
                      {/*      const formInput = document.getElementById("focused-input");*/}
                      {/*      if (formInput) {*/}
                      {/*        setReactInputValue(formInput, value)*/}
                      {/*      }*/}
                      {/*      this.setState({scannerValue:value})*/}
                      {/*    }}*/}
                      {/*    // onFocus={event => {*/}
                      {/*    //   this.setState({scannerFocused:true})*/}
                      {/*    // }}*/}
                      {/*    onBlur={event => {*/}
                      {/*      // const isInputBeingFocused = document.activeElement === document.getElementById('focused-input');*/}
                      {/*      // if(!isInputBeingFocused){*/}
                      {/*      //   event.target.focus()*/}
                      {/*      // }*/}
                      {/*      // console.log(isFocused); // true if scanner input is focused*/}
                      {/*    }}*/}
                      {/*    onKeyDown={event => {*/}
                      {/*      if((event.key === 'Enter') || (event.key === 'Tab')){*/}
                      {/*        const formInput = document.getElementById("focused-input");*/}
                      {/*        if (formInput) {*/}
                      {/*          setReactInputValue(formInput, scannerValue+"\t")*/}
                      {/*        }*/}
                      {/*        this.setState({scannerValue:""})*/}
                      {/*      }*/}
                      {/*    }}*/}
                      {/*/>*/}
                    </div>
                  </div>
                  <Row>
                    <Col xs={12} xl={12}>
                      <Row>
                        <Col md={12}>
                          <AssemblyFormBasicInformationCard
                              ref={this.assemblyFormBasicInformationRef}
                              formStep={formStep}
                              nextPage={() => {
                                this.nextPage()
                              }}
                              previousPage={() => {this.previousPage()}}
                              postProcessingRef={this.props.postProcessingRef}
                              submitUpdate={(assemblyStatus) => this.submitUpdate(assemblyStatus)}
                              assembly={assembly}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col id="default-scanner-wrapper">
                          <div
                              id="scanner-input"
                              tabIndex={0}
                              contentEditable
                              suppressContentEditableWarning
                              inputMode="text"
                              ref={this.scannerInputRef}
                              style={{
                                position: 'absolute',
                                opacity: 0,
                                width:"0.1px",
                                height:"0.1px",
                                // left: '-9999px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                              }}
                              // style={{
                              //   position: 'relative',
                              //   // opacity: 0,
                              //   // left: '-9999px',
                              //   whiteSpace: 'nowrap',
                              //   // overflow: 'hidden',
                              // }}
                              onBlur={(event) => {
                                // Don't force re-focus here — let focusin handle it
                              }}
                              onInput={(event) => {
                                let value = event.currentTarget.textContent || "";
                                let enter = false;
                                if (/[\r\n\t]/.test(value)) {
                                  enter = true;
                                  value = value.replace(/[\r\n\t]+/g, '');
                                }
                                const formInput = document.getElementById("focused-input");
                                if (formInput) {
                                  setReactInputValue(formInput, value);
                                }
                                // scannerValue = value
                                if(enter){
                                  let scannerValue = ''
                                  this.scannerInputRef.current.textContent = ''
                                  // this.setState({scannerValue})
                                }else{
                                  // this.setState({ scannerValue});
                                }
                              }}
                              onKeyDown={(event) => {
                                if (event.key === "Enter" || event.key === "Tab") {
                                  event.preventDefault();
                                  const formInput = document.getElementById("focused-input");
                                  let scannerValue = formInput.value + "\t"
                                  if (formInput) {
                                    setReactInputValue(formInput, scannerValue);
                                  }
                                  this.scannerInputRef.current.textContent = ''
                                  // this.setState({ scannerValue: "" }, () => {
                                  // });
                                }
                              }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          {
                            formStep===1&&(this.assemblyControlCard())
                          }
                          {
                            formStep===2&&(this.assemblyComponentCard())
                          }
                          {
                            formStep===3&&(this.assemblyRectifierControllerCard())
                          }
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {super.render()}
                </div>
            )
          }}
        </AuthConsumer>
    );
  };

  assemblyControlCard = () =>{
    let {assembly, formStep, validation, validationMessage} = this.state
    if(isEmpty(assembly)){
      assembly = {}
    }
    return(
        <AssemblyControllerFWVersionFormCard
            updateProperties={(key, value) => this.updateProperties(key, value)}
            assembly={assembly}
            ref={this.assemblyControllerFWVersionFormRef}
            onPassed={() => this.nextPage()}
        />
    )
  }

  assemblyComponentCard = () =>{
    let {assembly, formStep, validation, validationMessage} = this.state
    if(isEmpty(assembly)){
      assembly = {}
    }
    return(
        <AssemblyComponentFormCard
            updateProperties={(key, value) => this.updateProperties(key, value)}
            assembly={assembly}
            ref={this.assemblyComponentRef}
            onPassed={() => this.nextPage()}
        />
    )
  }

  assemblyRectifierControllerCard = () =>{
    let {assembly, formStep, validation, validationMessage} = this.state
    if(isEmpty(assembly)){
      assembly = {}
    }
      return(
          <AssemblyRectifierControllerFormCard
              updateProperties={(key, value) => this.updateProperties(key, value)}
              assembly={assembly}
              ref={this.assemblyRectifierControllerRef}
              onPassed={() => {
                if(this.assemblyFormBasicInformationRef){
                  this.assemblyFormBasicInformationRef.current.confirmSubmission()
                }
              }}
          />
      )
  }

}
// export default Object.assign(ProfilePage, {ENDPOINT : "/profile"})

const ENDPOINT = "/assembly/form"
const TITLE = label.AssemblyFormSubmission
const PAGE = {ENDPOINT: ENDPOINT, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(AssemblyFormControlPage, PAGE)
